export const HashScrollMixin = {
  methods: {
    async scrollIntoView(hash) {
      this.isScrolling = true;
      document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth' });
      history.replaceState(null, null, '#' + hash);
      setTimeout(() => (this.isScrolling = false), 1000);
    },
    scrollHandler() {
      if (this.isScrolling) return;
      const anchorsInViewport = [];
      document.querySelectorAll('li.section').forEach((anchor) => {
        const top = anchor.offsetTop;
        const height = anchor.offsetHeight;
        if (
          top < document.body.scrollTop + window.innerHeight &&
          top + height > document.body.scrollTop + window.innerHeight / 4
        )
          anchorsInViewport.push(anchor);
      });
      if (!anchorsInViewport.length) return;
      history.replaceState(null, null, '#' + anchorsInViewport[0].id);
    },
  },
  async mounted() {
    if (this.$route.hash) {
      document.getElementById(this.$route.hash.replace('#', ''))?.scrollIntoView({ behavior: 'instant' });
    }
    this.$nextTick(() => document.body.addEventListener('scroll', this.scrollHandler));
  },
  beforeDestroy() {
    document.body.removeEventListener('scroll', this.scrollHandler);
  },
};
